import { Ingredient } from "@/models/ingredient";

export default class Mixture {
  static weight(mixture: Ingredient[]): number {
    return mixture.reduce((accu, ingredient) => accu + ingredient.amountInGrams, 0.0);
  }

  static calories(mixture: Ingredient[]): number {
    return mixture.reduce((accu, ingredient) => accu+ingredient.calories(), 0.0);
  }
}
